export const VIEW_WIDTH_CSS_VAR = '--ws-editor-view-width';
export const VIEW_BORDER_CSS_VAR = '--ws-editor-view-border';
